<div class="plan-details" *ngIf="!isLoading; else loadingTpl" [class.embedded]="embeddedMode">
  <umkt-breadcrumb *ngIf="!embeddedMode" [items]="breadcrumbItems" [separator]="'>'"></umkt-breadcrumb>

  <umkt-error-display *ngIf="error && !plan" [retryCount]="retryCount" (retry)="handleRetry()">
  </umkt-error-display>

  <section class="plan-details__content" *ngIf="plan as p">
    <div class="plan-details__header">
      <h2 class="plan-details__title">{{ p.productName }} {{ p.variationName}}</h2>
    </div>

    <div class="plan-details__body">
      <div class="plan-details__description" [innerHTML]="p.description"></div>

      <!-- <h3 class="plan-details__section-title">Aplicativos e serviços incluídos:</h3> -->
      <div class="plan-details__apps">
        <ng-container *ngFor="let app of (p.includedFeatures || [])">
          <img [src]="'/assets/icons/' + app.icon" [alt]="app.name" class="plan-details__app-icon" />
        </ng-container>
      </div>


      <!-- <div class="plan-details__apps">
        <umkt-icon *ngFor="let _ of (p.includedFeatures || [])" [icon]="{ name: 'apps', type: 'material-icons', size: 'sm' }"></umkt-icon>
      </div> -->

      <div class="plan-details__info-card">
        <h4 class="plan-details__info-title">{{ 'pages.planDetails.info.generalTitle' | i18n }}</h4>
        <ul class="plan-details__info-list">
          <li class="plan-details__info-item" *ngIf="shouldShowDomainOnly">
            <span>{{ 'pages.planDetails.info.domain' | i18n }}</span>
            <strong>{{ domainOnlyValue }}</strong>
          </li>
          <li class="plan-details__info-item" *ngIf="shouldShowDomain">
            <span>{{ 'pages.planDetails.info.accessEmail' | i18n }}</span>
            <strong>{{ domainDisplayValue }}</strong>
          </li>
          <li class="plan-details__info-item" *ngIf="plan?.planTerms && hasInitialPassword">
            <span>{{ 'pages.planDetails.info.tempPassword' | i18n }}</span>
            <strong class="password-field">
              {{ showPassword ? initialPassword : maskedPassword }}
              <button class="password-toggle-btn" (click)="togglePasswordVisibility()"
                [attr.aria-label]="(showPassword ? 'pages.planDetails.actions.hidePassword' : 'pages.planDetails.actions.showPassword') | i18n"
                type="button">
                <span class="material-icons">{{ showPassword ? 'visibility_off' : 'visibility' }}</span>
              </button>
            </strong>
          </li>
          <li class="plan-details__info-item">
            <span>{{ 'pages.planDetails.info.quantity' | i18n }}</span>
            <strong>
              {{ (p.maxUsersDevices || 1) }}
              {{ ((p.maxUsersDevices || 1) === 1 ? 'pages.planDetails.info.licenseSingular' :
              'pages.planDetails.info.licensePlural') | i18n }}
            </strong>
          </li>
          <li class="plan-details__info-item">
            <span>{{ 'pages.planDetails.info.contractTerm' | i18n }}</span>
            <strong>
              {{ p.billingCycle === 'monthly' ? ('pages.planDetails.info.termMonthly' | i18n) : (p.billingCycle ===
              'annual' ? ('pages.planDetails.info.termAnnual' | i18n) : '-') }}
            </strong>
          </li>

          <li class="plan-details__info-item">
            <span>{{ 'pages.planDetails.info.expirationDate' | i18n }}</span>
            <strong>{{ p.expirationDate ? (p.expirationDate | date:'dd/MM/yyyy') : '-' }}</strong>
          </li>
          <li class="plan-details__info-item">
            <span>{{ 'pages.planDetails.info.paymentMethod' | i18n }}</span>
            <strong class="payment-method-details">
              <img *ngIf="p.cardFlag" [src]="p.cardFlag | getCreditCardIconSrc:(p.flow || undefined)"
                [alt]="p.cardFlag || ((p.flow === 'BOLETO_CARTAO' || !p.flow) ? 'boleto' : 'fatura claro')"
                class="card-flag-icon">
              {{ p?.cardFlag | paymentText: p?.lastFourDigits:(p.flow || undefined) }}
            </strong>
          </li>
          <li class="plan-details__info-item" *ngIf="shouldShowHostopiaUsername">
            <span>{{ 'pages.planDetails.info.userName' | i18n }}</span>
            <strong>{{ hostopiaUsername }}</strong>
          </li>
          <li class="plan-details__info-item" *ngIf="isTelemedicinePlan">
            <span>{{ 'pages.planDetails.info.firstAccessPassword' | i18n }}</span>
            <strong class="password-field">
              {{ showTelemedicinePassword ? telemedicinePassword : maskedTelemedicinePassword }}
              <button class="password-toggle-btn" (click)="toggleTelemedicinePasswordVisibility()"
                [attr.aria-label]="(showTelemedicinePassword ? 'pages.planDetails.actions.hidePassword' : 'pages.planDetails.actions.showPassword') | i18n"
                type="button">
                <span class="material-icons">{{ showTelemedicinePassword ? 'visibility_off' : 'visibility' }}</span>
              </button>
            </strong>
          </li>
          <li class="plan-details__info-item" *ngIf="shouldShowAccessLink && !isTelemedicinePlan"
            [class.no-bullet]="isPartnerOrigin">
            <span *ngIf="!isPartnerOrigin">
              {{ 'pages.planDetails.info.accessLink' | i18n }}
            </span>

            <strong>
              <ng-container *ngIf="isPartnerOrigin; else normalAccessLink">
                <a [href]="accessLink" target="_blank" rel="noopener noreferrer" class="btn btn-primary activation-btn">
                  {{ 'pages.planDetails.actions.activateAccess' | i18n }}
                </a>
              </ng-container>

              <ng-template #normalAccessLink>
                <a [href]="accessLink" target="_blank" rel="noopener noreferrer" class="access-link">
                  {{ accessLink }}
                </a>
              </ng-template>
            </strong>
          </li>
        </ul>
        <div class="plan-details__access-action" *ngIf="shouldShowAccessLink && isTelemedicinePlan">
          <a [href]="accessLink" target="_blank" rel="noopener noreferrer" class="btn btn-primary activation-btn">
            {{ 'pages.planDetails.actions.accessAccount' | i18n }}
          </a>
        </div>
        <div class="plan-details__access-action" *ngIf="shouldShowPortalLink">
          <a [href]="portalLink" target="_blank" rel="noopener noreferrer" class="btn btn-primary activation-btn">
            {{ 'pages.planDetails.actions.accessHere' | i18n }}
          </a>
        </div>

        <div class="plan-details__actions" *ngIf="isActive">

          <umkt-action-button *ngIf="canShowChangePlanButton" [label]="'pages.planDetails.actions.changePlan' | i18n"
            variant="outline" (clicked)="openChangePlanModal()">
          </umkt-action-button>
          <umkt-action-button *ngIf="p.cardToken" [label]="'pages.planDetails.actions.changePayment' | i18n"
            variant="outline" (clicked)="onChangePaymentMethod(p.uuid)">
          </umkt-action-button>
          <div class="plan-details__actions-stack"
            [style.marginTop]="!(shouldShowAccessLink && (isPartnerOrigin || isTelemedicinePlan) || shouldShowPortalLink) ? '16px' : null">
            <umkt-action-button [label]="'pages.planDetails.actions.planHistory' | i18n" variant="outline"
              (clicked)="showPlanHistoryModal = true">
            </umkt-action-button>
            <umkt-action-button
              [label]="(isCanceling ? 'pages.planDetails.actions.canceling' : 'pages.planDetails.actions.cancelPlan') | i18n"
              variant="primary" (clicked)="openClearCartConfirm()">
            </umkt-action-button>
          </div>
        </div>
        <div class="plan-details__actions" *ngIf="!isActive">
          <umkt-action-button [label]="'pages.planDetails.actions.planHistory' | i18n" variant="outline"
            (clicked)="showPlanHistoryModal = true">
          </umkt-action-button>
        </div>
      </div>
    </div>
    <umkt-change-plan-modal *ngIf="plan" [open]="showChangePlanModal" [plan]="plan"
      [productUuid]="plan.parentProduct?.uuid" [initialQuantity]="plan.maxUsersDevices || 1"
      [canChangeQuantity]="canChangeQuantity" [canChangePlan]="canChangePlan" (closed)="showChangePlanModal = false"
      (confirmQuantityChange)="handleQuantityUpdate($event)"
      (confirmPlanChange)="handlePlanUpdate($event)"></umkt-change-plan-modal>

    <umkt-plan-history-modal [open]="showPlanHistoryModal" [planUuid]="currentPlanUuid"
      [productName]="plan?.productName || ''" (closed)="showPlanHistoryModal = false"></umkt-plan-history-modal>
  </section>
  <umkt-confirm-modal [open]="showCancelPlanConfirm" [title]="'pages.planDetails.modal.title' | i18n"
    [message]="cancelModalMessage" (confirm)="handleCancelPlanConfirm()" (cancel)="handleCancelPlanClose()"
    (closed)="handleCancelPlanClose()" [confirmText]="'pages.planDetails.modal.confirm' | i18n"
    [cancelText]="'pages.planDetails.modal.keep' | i18n"></umkt-confirm-modal>
</div>

<ng-template #loadingTpl>
  <umkt-loading [isLoading]="true" [size]="'md'" [mode]="'contained'">
  </umkt-loading>
</ng-template>